import React from "react";

const DetalleOrganizacion = ({ userPermissions }) => {
	return (
		<>
			<div className="text-center text-2xl font-semibold text-sky-700">
				Organización: {userPermissions?.organizacion}
			</div>

			<div className="flex flex-col items-center justify-center">
				<div className="flex flex-row items-center w-full mt-2" key="nombre">
					<div className="mx-2 w-1/2 text-gray-600 font-semibold text-right">
						Representante:
					</div>
					<div className="mx-2 w-1/2 text-gray-600 text-left">
						{userPermissions?.nombre}
					</div>
				</div>

				<div
					className="flex flex-row items-center w-full mt-2"
					key="clave_organizacion"
				>
					<div className="mx-2 w-1/2 text-gray-600 font-semibold text-right">
						Clave:
					</div>
					<div className="mx-2 w-1/2 text-gray-600 text-left">
						{userPermissions?.clave_organizacion}
					</div>
				</div>

				<div
					className="flex flex-row items-center w-full mt-2"
					key="correo_avisos"
				>
					<div className="mx-2 w-1/2 text-gray-600 font-semibold text-right">
						Correo de avisos 1:
					</div>
					<div className="mx-2 w-1/2 text-gray-600 text-left">
						{userPermissions?.correo_avisos}
					</div>
				</div>

				<div
					className="flex flex-row items-center w-full mt-2"
					key="correo_avisos_2"
				>
					<div className="mx-2 w-1/2 text-gray-600 font-semibold text-right">
						Correo de avisos 2:
					</div>
					<div className="mx-2 w-1/2 text-gray-600 text-left">
						{userPermissions?.correo_avisos_2}
					</div>
				</div>

				<div
					className="flex flex-row items-center w-full mt-2"
					key="telefono_avisos"
				>
					<div className="mx-2 w-1/2 text-gray-600 font-semibold text-right">
						Teléfono de avisos 1:
					</div>
					<div className="mx-2 w-1/2 text-gray-600 text-left">
						{userPermissions?.telefono_avisos}
					</div>
				</div>

				<div
					className="flex flex-row items-center w-full mt-2"
					key="telefono_avisos_2"
				>
					<div className="mx-2 w-1/2 text-gray-600 font-semibold text-right">
						Teléfono de avisos 2:
					</div>
					<div className="mx-2 w-1/2 text-gray-600 text-left">
						{userPermissions?.telefono_avisos_2}
					</div>
				</div>
			</div>
		</>
	);
};

export default DetalleOrganizacion;
